import React from "react";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import * as confirm from "../../../assets/lottieAnimation/confirm.json";
import FadeIn from "react-fade-in/lib/FadeIn";
import Lottie from "react-lottie";

const ModalConfirmApprove = ({ submitSuccess, handleCloseSubmitSuccess }) => {

  return (
    <Modal
      centered
      isOpen={submitSuccess}
      toggle={() => {
        handleCloseSubmitSuccess();
      }}
    >
      <ModalBody>
        <Row>
          <Col xxl={12} className="d-flex justify-content-center">
            <h1>ดำเนินการเสร็จสิ้น</h1>
          </Col>
          <Col xxl={12} className="d-flex justify-content-center mt-4">
            <div
              className="p-4"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                height: "150px",
                width: "150px",
                border: "5px solid black",
              }}
            >
              <FadeIn>
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: confirm.default,
                    rendererSettings: {
                      preserveAspectRatio: "xMidYMid slice",
                    },
                  }}
                  width={180}
                  height={180}
                />
              </FadeIn>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ModalConfirmApprove;
